export default __webpack_public_path__ + "static/tasks-dragged-ef671c1122d58066815995fe75493dd1.mp4";